module.exports = __webpack_public_path__ + "img/education.f84394d0.png";